import { Center, MenuItem as MenuItemC } from '@chakra-ui/react'
import type { IconDefinition } from '@fortawesome/fontawesome-common-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import chakraTokenToVar from '@/utils/chakraTokenToVar'

const ICON_COLOR = 'fg.subtle'

export default function MenuItem({
  value,
  icon,
  label,
  color,
  onClick,
  disabled = false,
}: {
  value: string
  icon: IconDefinition
  label: string
  color?: string
  onClick?: () => void
  disabled?: boolean
}): JSX.Element {
  return (
    <MenuItemC
      as="div"
      value={value}
      width="100%"
      fontSize="16px"
      color={color ?? 'fg'}
      isDisabled={disabled}
      icon={
        <Center minW="20px">
          <FontAwesomeIcon
            icon={icon}
            color={chakraTokenToVar(color ?? ICON_COLOR)}
            style={{ fontSize: '16px' }}
          />
        </Center>
      }
      onClick={onClick}
    >
      {label}
    </MenuItemC>
  )
}
